
/**
 * 평점별 분포
 */
export interface RatingDistribution {
  five: number;
  four: number;
  one: number;
  three: number;
  two: number;
}
